import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  GridDataResult,
  PageChangeEvent,
  RowClassArgs,
  SelectionEvent,
} from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { thumbnailsDownIcon } from '@progress/kendo-svg-icons';
import { forkJoin } from 'rxjs';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import {
  ColumnConfig,
  FieldValidation,
  ImportData,
} from 'src/app/features/common/models/column-config.model';
import { commonService } from 'src/app/services/common.service';
import { eplService } from 'src/app/services/epl.service';
import { ExportService } from 'src/app/services/export.service';
import { mwoService } from 'src/app/services/mwo.service';

@Component({
  selector: 'app-acd-epl-build',
  templateUrl: './acd-epl-build.component.html',
  styleUrl: './acd-epl-build.component.scss',
})
export class AcdEplBuildComponent {
  iconPacks = EMDMICONS;
  showFileUploadPopup: boolean = false;
  public selectedHeaderIds: Set<number> = new Set<number>();
  public selectedItemIds: Set<number> = new Set<number>();
  anchorElement: any;
  eplMasterViewData: Array<any> = [];
  eplChildViewData: Array<any> = [];
  eplChildData: Array<any> = [];
  eplMasterOgData: Array<any> = [];
  eplChildOgData: Array<any> = [];
  eplExportData: Array<any> = [];
  itemShortData: any[] = [];
  popupOpenField = '';
  popUpOpenFieldChangeItemId = 0;
  popupShow = false;
  popupTitle = '';
  openedItemIndex = -1;
  popupHeight = 440;
  popupWidth = 600;
  searchPlaceHolder = 'Search';
  serviceTypeList: any[] = [];
  serviceTypeSelectColumn: any[] = [];
  exportColumns = [
    'EMDM Key',
    'Tag',
    'EPL Short',
    'EPL Long',
    'Sub Assembly Short',
    'Item Short',
    'Item Long',
    'Quantity',
    'Description',
  ];

  mandatoryFieldList: any[] = ['quantity'];

  public expandedState = false;
  showAddOrDeletePopup: boolean = false;
  showItemShortPopup: boolean = false;
  crNo = 0;
  showTagPopup: boolean = false;
  popupGridColumn: ColumnConfig[] = [
    { field: 'itm', title: 'Item Number', width: 120, isSearchProperty: true },
    {
      field: 'description1',
      title: 'Description',
      width: 280,
      isSearchProperty: true,
    },
  ];
  popupDataList!: GridDataResult;
  skip = 0;
  pageSize = 5;
  searchText: string = '';
  @Input() set setCRNo(crNo: number) {
    if (crNo > 0 && this.crNo != crNo) {
      this.crNo = crNo;
      this.loadGridData();
    }
  }

  isUserHaveAccess: boolean = true;

  @Input() set setCrDetails(crDetails: any) {
    let admin = sessionStorage.getItem('admin');
    let specialist = sessionStorage.getItem('specialist');
    if (crDetails) {
      this.isUserHaveAccess =
        specialist == 'true' ||
        admin == 'true' ||
        (crDetails?.isUserCanAccessRequest ?? false);
    } else {
      this.isUserHaveAccess = false;
    }
  }

  fieldValidationInput!: FieldValidation[];

  @Output() stepNavigateTo = new EventEmitter<string>();

  eplList: Array<{ id: number; text: string }> = [];
  subAssemblyList: any[] = [];
  eplId: number = 0;
  eplItems: string = '';
  selectedParameterId: number = 0;
  eplChildDeletedItemIds: Set<number> = new Set();
  constructor(
    private commonService: commonService,
    private exportService: ExportService,
    private eplService: eplService,
    private mwoService: mwoService
  ) {}

  loadGridData() {
    this.selectedHeaderIds.clear();
    this.selectedItemIds.clear();
    this.eplChildOgData = [];
    this.eplChildViewData = [];
    this.eplMasterOgData = [];
    this.eplMasterViewData = [];
    this.eplList = [];
    this.subAssemblyList = [];
    this.addEPlForm.reset();
    this.eplId = 0;
    this.eplItems = '';
    let requestList = [
      this.eplService.getMasterGridData(this.crNo),
      this.eplService.getChildGridData(this.crNo),
    ];
    this.eplChildDeletedItemIds.clear();

    forkJoin(requestList).subscribe({
      next: (response: any[]) => {
        if (requestList.length == response.length) {
          this.getHeaderGridData(response[0]);
          this.getItemGridData(response[1]);
        }
      },
    });
  }

  addEPlForm = new FormGroup({
    eplId: new FormControl(0, [Validators.required, Validators.min(1)]),
    subAssemblyId: new FormControl(0, [Validators.required]),
    eplItemIds: new FormControl('', [Validators.required]),
  });

  readyForUndoList_Header = new Array<any>();
  readyForUndoList_Item = new Array<any>();

  getHeaderGridData(data: any) {
    if (data?.length > 0) {
      data = data
        .map((x: any) => {
          x.fieldChangedList = [];
          x.isLocalAdd = false;
          x.tagNumberList = x.tagNumber?.split(',');
          x.tagNumber_View =
            x.tagNumber?.split(',')?.slice(0, 5).join(',<br>') ?? '';
          if (x.tagNumberList?.length > 5) {
            x.tagNumber_View += '...';
          }
          if (x.modifiedFields != null && x.modifiedFields != '') {
            x.fieldChangedList = x.modifiedFields.split(';');
            this.readyForUndoList_Header.push(x);
          }

          return x;
        })
        .sort((x: any, y: any) => x.changeItemEPLId - y.changeItemEPLId);

      this.eplMasterViewData = JSON.parse(
        JSON.stringify(data.filter((x: any) => x.isStaging))
      );
      this.eplMasterOgData = JSON.parse(
        JSON.stringify(data.filter((x: any) => x.isStaging))
      );

      if (this.eplMasterViewData.length > 0) {
        this.eplList = this.eplMasterViewData.map((x: any) => {
          return {
            id: x.changeItemEPLId,
            text: x.eplShort + ' - ' + x.eplLong,
          };
        });

        this.eplId = this.eplList[0].id;
      }
    }
  }

  getItemGridData(data: any) {
    if (data) {
      data = data
        .map((childData: any) => {
          childData.fieldChangedList = [];
          childData.tagNumberList = childData.tagNumber?.split(',');
          childData.tagNumber_View =
            childData.tagNumber?.split(',')?.splice(0, 5).join(',<br>') ?? '';
          if (childData.tagNumberList?.length > 5) {
            childData.tagNumber_View += '...';
          }
          let parentIndex = this.eplMasterViewData.findIndex(
            (masterData: any) => childData.eplId == masterData.changeItemEPLId
          );
          if (parentIndex > -1) {
            childData.isParentIndexIsOdd = parentIndex + 1;
          }
          if (
            childData.modifiedFields != null &&
            childData.modifiedFields != ''
          ) {
            childData.fieldChangedList = childData.modifiedFields.split(';');
            this.readyForUndoList_Item.push(childData);
          }

          return childData;
        })
        .sort((x: any, y: any) => x.eplId - y.eplId);

      this.eplChildData = JSON.parse(
        JSON.stringify(data.filter((x: any) => x.isStaging))
      );
      this.eplChildViewData = JSON.parse(
        JSON.stringify(data.filter((x: any) => x.isStaging))
      );

      if (this.eplChildViewData.length > 0) {
        const eplChildViewDataOrg:any = this.eplChildViewData;
        this.eplChildViewData = this.eplChildViewData.map((childData: any) => {
          if(childData.itemLong != childData.itemShort) {
            childData.hideDelete = eplChildViewDataOrg.some((orgChildData: any) => orgChildData.subAssemblyComp === childData.itemShort);

          }
          return childData;
        });
      }
      this.eplChildOgData = JSON.parse(
        JSON.stringify(data.filter((x: any) => !x.isStaging))
      );

      this.setExportData();
    }
  }

  public expandCollapseContent(): void {
    this.expandedState = !this.expandedState;
  }

  onSelectionChangeEvent(event: SelectionEvent, isHeader: boolean = false) {
    if (isHeader)
      this.selectedHeaderIds = this.commonService.onGridSelection(
        this.selectedHeaderIds,
        event,
        'changeItemId'
      );
    else
      this.selectedItemIds = this.commonService.onGridSelection(
        this.selectedItemIds,
        event
      );
  }

  validateHeaderData(): any[] {
    let validationMsgList: any = [];

    this.eplMasterViewData.forEach((x: any, index: number) => {
      let rowMsgList: string[] = [];
      if (x.fieldChangedList?.length > 0) {
        x.modifiedFields = x?.fieldChangedList?.join(';') ?? '';
      } else {
        x.modifiedFields = '';
      }

      let eplShortElement = document.getElementById(
        `${x.changeItemId}_eplShort`
      );
      let eplLongElement = document.getElementById(`${x.changeItemId}_eplLong`);
      Object.keys(x).forEach((prop: any) => {
        if (prop == 'eplShort') {
          if (x[prop] == null || x[prop] == '') {
            rowMsgList.push('EPL Short must be set.');

            if (eplShortElement) {
              eplShortElement?.classList.add('field-mandatory');
            }
          } else {
            if (
              eplShortElement?.classList?.contains('field-mandatory') ||
              eplShortElement?.classList?.contains('error')
            ) {
              eplShortElement?.classList.remove('field-mandatory');
            }
          }
        }

        if (prop == 'eplLong') {
          if (x[prop] == null || x[prop] == '') {
            rowMsgList.push('EPL Long must be set.');

            if (eplLongElement) {
              eplLongElement?.classList.add('field-mandatory');
            }
          } else {
            if (
              eplLongElement?.classList?.contains('field-mandatory') ||
              eplLongElement?.classList?.contains('error')
            ) {
              eplLongElement?.classList.remove('field-mandatory');
            }
          }
        }
      });

      if (rowMsgList.length > 0) {
        validationMsgList.push(`Line ${index + 1}: ${rowMsgList.join(', ')}`);
      }
    });

    return validationMsgList;
  }

  validateItemData(): any[] {
    let validationMsgList: any[] = [];

    this.eplChildViewData.forEach((x: any, index: number) => {
      let rowMsgList: string[] = [];
      if (x.fieldChangedList?.length > 0) {
        x.modifiedFields = x?.fieldChangedList?.join(';') ?? '';
      } else {
        x.modifiedFields = '';
      }

      let quantityElement = document.getElementById(`${x.bomId}_quantity`);
      let eplLongElement = document.getElementById(`${x.bomId}_eplLong`);
      let itemShortElement = document.getElementById(`${x.bomId}_itemShort`);

      Object.keys(x).forEach((prop: any) => {
        if (prop == 'quantity') {
          if (x[prop] == null || x[prop] == '' || x[prop] == 0) {
            if (x.acdAction == 'No change') {
              if (
                quantityElement?.classList?.contains('field-mandatory') ||
                quantityElement?.classList?.contains('error')
              ) {
                quantityElement?.classList.remove('field-mandatory');
              }
              return;
            }
            rowMsgList.push('Quantity must be > 0.');
            if (quantityElement) {
              quantityElement?.classList.add('field-mandatory');
            }
          } else {
            if (
              quantityElement?.classList?.contains('field-mandatory') ||
              quantityElement?.classList?.contains('error')
            ) {
              quantityElement?.classList.remove('field-mandatory');
            }
          }
        }

        if (prop == 'eplLong') {
          if (x[prop] == null || x[prop] == '') {
            rowMsgList.push('EPL Long must be set.');
            if (eplLongElement) {
              eplLongElement?.classList.add('field-mandatory');
            }
          } else {
            if (
              eplLongElement?.classList?.contains('field-mandatory') ||
              eplLongElement?.classList?.contains('error')
            ) {
              eplLongElement?.classList.remove('field-mandatory');
            }
          }
        }

        if (prop == 'itemShort') {
          if (
            x.acdAction.toLowerCase() != 'no change' &&
            (x[prop] == null || x[prop] == '')
          ) {
            rowMsgList.push('Item Short must be > 0.');
            if (itemShortElement) {
              itemShortElement?.classList.add('field-mandatory');
            }
          } else {
            if (
              itemShortElement?.classList?.contains('field-mandatory') ||
              itemShortElement?.classList?.contains('error')
            ) {
              itemShortElement?.classList.remove('field-mandatory');
            }
          }
        }
      });

      if (rowMsgList.length > 0) {
        validationMsgList.push(`Line ${index + 1}: ${rowMsgList.join(', ')}`);
      }
    });

    return validationMsgList;
  }

  saveAndAddToCr() {
    let isActionConfirmed = window.confirm('Are you sure?');

    if (isActionConfirmed) {
      let headerValidationList = this.validateHeaderData();
      let itemValidationList = this.validateItemData();
      if (headerValidationList.length == 0 && itemValidationList.length == 0) {
        this.saveBuild();
      } else {
        let fullMsg = '';
        if (headerValidationList.length > 0 && itemValidationList.length > 0) {
          fullMsg =
            `There are ${
              headerValidationList.length + itemValidationList.length
            } errors: <br>Header Error: - <br>` +
            headerValidationList.join('<br>');
          fullMsg += `<br>Item Error: - <br>`;
          fullMsg += itemValidationList.join('<br>');
        } else if (headerValidationList.length > 0) {
          fullMsg =
            `There are ${headerValidationList.length} errors: - <br>` +
            headerValidationList.join('<br>');
        } else {
          fullMsg =
            `There are ${itemValidationList.length} errors: - <br>` +
            itemValidationList.join('<br>');
        }

        this.commonService.showNotificationMessage(fullMsg, 'error', 'center');
      }
    }
  }

  saveBuild() {
    let payload = {
      eplHeaderItems: this.eplMasterViewData,
      eplBomItems: this.eplChildViewData,
    };
    if (this.eplChildDeletedItemIds.size > 0) {
      let deletePayload = {
        crid: this.crNo,
        bomIds: Array.from(this.eplChildDeletedItemIds).join(','),
      };

      this.eplService.deleteBomItemsUsingPopup(deletePayload).subscribe({
        next: (response: any) => {
          if (response) {
            this.saveEPL(payload);
          }
        },
        error: (err: any) => {
          this.saveEPL(payload);
        },
      });
    } else {
      this.saveEPL(payload);
    }
  }

  saveEPL(payload: any) {
    this.eplService.saveAndAddToCR(this.crNo, payload).subscribe({
      next: (response: any) => {
        if (response == 'Success') {
          this.commonService.showNotificationMessage(
            'EPL added successfully',
            'success',
            'center',
            200,
            false
          );
          this.stepNavigateTo.emit('Summary');
        }
      },
      error: (error: any) => {},
    });
  }

  searchString = '';
  placeHolderValue = '';
  dataList: any[] = [];
  columnConfig: ColumnConfig[] = [];
  addTagText = '';
  selectedEPLShort = 0;

  openTagNumberPopup(dataItem: any, rowIndex: number) {
    this.showTagPopup = true;
    this.addTagText = '';
    this.selectedEPLShort = dataItem.eplShort;
    this.tagSelectedIds = [];
    this.popupTitle = '';
    this.popupHeight = 500;
    this.popupWidth = 600;
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let data = {
      skip: this.skip,
      pageSize: 100,
      searchText: this.searchString,
    };
  }

  popupEquipmentSearch() {
    let payload = {
      crId: this.crNo,
      tag: this.searchString,
      eplShortId: this.selectedEPLShort,
    };

    this.tagSelectedIds = [];

    this.eplService.getEplTag(payload).subscribe({
      next: (response: any) => {
        if (response.length > 0) {
          this.dataList = response;
        }
      },
      error: () => {
        this.dataList = [];
      },
    });
  }

  resetData() {
    this.skip = 0;
    this.searchString = '';
    this.dataList = [];
    this.addTagText = '';
  }

  tagSelectedIds: number[] = [];
  equipmenTagSelectionChange() {
    if (this.tagSelectedIds.length > 0) {
      let tags: Set<string> = new Set<string>();
      this.tagSelectedIds.forEach((index) => {
        if (this.dataList[index].tag) {
          tags.add(this.dataList[index].tag);
        }
      });

      this.addTagText = Array.from(tags).join(',');
    } else {
      this.addTagText = '';
    }
  }

  addEplTag() {
    if (this.addTagText != '') {
      let isConfimed = window.confirm('Confirm Add Tags?');
      if (isConfimed) {
        let payload = {
          crId: this.crNo,
          tag: this.addTagText,
          eplShortId: this.selectedEPLShort,
        };

        this.eplService.addEplTag(payload).subscribe({
          next: (response: any) => {
            this.closePopup();
            if (response == 'Success') {
              this.commonService.showNotificationMessage(
                `${response}`,
                'success',
                'center'
              );
              this.loadGridData();
            } else if (response == 'Tag/s already added') {
              this.commonService.showNotificationMessage(
                `${response}`,
                'warning',
                'center'
              );
            }
          },
          error: () => {
            this.closePopup();
          },
        });
      }
    } else {
      this.commonService.showNotificationMessage(
        `Select any equipment tag to add.`,
        'warning',
        'center'
      );
    }
  }

  openAddOrDeletePopup() {
    if (this.eplList.length > 0) {
      this.eplId = this.eplList[0].id;
    }
    this.eplService.getSubAssemblyForEPLPopUp(this.eplId).subscribe({
      next: (response: any) => {
        if (response?.length > 0) {
          this.subAssemblyList = response.map((x: any) => {
            return {
              itemShort: x.itemShort,
              itemValue: x.itemValue,
            };
          });
          this.subAssemblyList = [ {
              itemShort: 0,
              itemValue: '- No Sub- Assembly -',
            }, 
            ...this.subAssemblyList ];
          this.selectedParameterId = this.subAssemblyList[0].itemShort;
        } else {
          this.subAssemblyList = [
            {
              itemShort: 0,
              itemValue: '- No Sub- Assembly -',
            },
          ];
          this.selectedParameterId = this.subAssemblyList[0].itemShort;
        }
        this.showAddOrDeletePopup = true;
      },
    });
    this.eplItems = '';
    this.addEPlForm.reset();

    this.popupTitle = 'Add or Delete items for an EPL';
    this.popupHeight = 350;
    this.popupWidth = 500;
  }

  onEplChange(event: any) {
    this.eplService.getSubAssemblyForEPLPopUp(event).subscribe({
      next: (response: any) => {
        if (response?.length > 0) {
          this.subAssemblyList = response.map((x: any) => {
            return {
              itemShort: x.itemShort,
              itemValue: x.itemValue,
            };
          });
          
          this.subAssemblyList = [ {
              itemShort: 0,
              itemValue: '- No Sub- Assembly -',
            }, 
            ...this.subAssemblyList ];

          // Reset selectedParameterId to the first item after loading new data
          this.selectedParameterId = this.subAssemblyList[0].itemShort || 0;
        } else {
          this.subAssemblyList = [];
          this.selectedParameterId = 0;
        }
      },
    });
  }

  addDeleteItem(isAdd: boolean = false) {
    this.addEPlForm.markAllAsTouched();
    this.eplItems = this.eplItems.trim().replace(/\n/g, ',');
    if (this.addEPlForm.valid && this.eplItems != '') {
      let payload = {
        changeRequestId: this.crNo,
        selectedEplId: this.eplId,
        selectedParentItemId: this.selectedParameterId || 0,
        selectedItemIds: this.eplItems.split(',').map((x: any) => parseInt(x)),
      };
      this.eplService.addDeleteItems(payload, isAdd).subscribe({
        next: (response: any) => {
          if (response) {
            if (response.errors?.length > 0) {
              this.commonService.showNotificationMessage(
                `${response.errors}`,
                'error',
                'center'
              );
              this.closePopup();
            } else {
              this.addDeleteItemResult(isAdd);
            }
          }
        },
        error: () => {
          this.closePopup();
        },
      });
    }
  }

  addDeleteItemResult(isAdd: boolean = false) {
    let payload = {
      isUIItemsGridEmpty: this.eplChildViewData.length == 0,
      changeRequestId: this.crNo,
      selectedEplId: this.eplId,
      selectedParentItemId: this.selectedParameterId || 0,
      selectedItemIds: this.eplItems.split(',').map((x: any) => parseInt(x)),
    };

    this.closePopup();
    this.eplService.addDeleteItemsResult(payload, isAdd).subscribe({
      next: (response: any) => {
        if (response) {
          if (response.errors?.length > 0) {
            this.commonService.showNotificationMessage(
              `${response.errors.join('<br>')}`,
              'error',
              'center'
            );
          } else {
            if (!response.isDeleted && response.result) {
              response.result = response.result.map((childData: any) => {
                childData.bomId = 0;
                childData.tagNumberList = childData.tagNumber?.split(',');
                childData.tagNumber_View =
                  childData.tagNumber?.split(',')?.splice(0, 5).join(',<br>') ??
                  '';
                childData.itemLong = String(childData.itemShort);
                if (childData.tagNumberList?.length > 5) {
                  childData.tagNumber_View += '...';
                }

                let parentIndex = this.eplMasterViewData.findIndex(
                  (masterData: any) =>
                    childData.eplId == masterData.changeItemEPLId
                );
                if (parentIndex > -1) {
                  childData.isParentIndexIsOdd = parentIndex + 1;
                }

                return childData;
              });

              this.eplChildViewData = [
                ...this.eplChildViewData,
                ...response.result,
              ];
              this.eplChildViewData = this.eplChildViewData.sort(
                (x: any, y: any) => x.eplId - y.eplId
              );
              this.setExportData();
            } else {
              if (response.isDeleted) {
                if (payload.selectedParentItemId > 0) {
                  this.eplChildViewData
                    .filter(
                      (x: any) =>
                        x.eplId == payload.selectedEplId &&
                        x.subAssemblyComp == payload.selectedParentItemId &&
                        payload.selectedItemIds.includes(x.itemShort)
                    )
                    .forEach((x: any) => {
                      this.eplChildDeletedItemIds.add(x.bomId);
                    });
                } else {
                  this.eplChildViewData
                    .filter(
                      (x: any) =>
                        x.eplId == payload.selectedEplId &&
                        payload.selectedItemIds.includes(x.itemShort)
                    )
                    .forEach((x: any) => {
                      this.eplChildDeletedItemIds.add(x.bomId);
                    });
                }
                if (payload.selectedParentItemId > 0) {

                  this.eplChildViewData = this.eplChildViewData.filter(
                    (x: any) =>
                      !(
                        x.eplId == payload.selectedEplId &&
                        x.subAssemblyComp == payload.selectedParentItemId &&
                        payload.selectedItemIds.includes(x.itemShort)
                      )
                  );
                } else {
                  this.eplChildViewData = this.eplChildViewData.filter(
                    (x: any) =>
                      !(
                        x.eplId == payload.selectedEplId &&
                        payload.selectedItemIds.includes(x.itemShort)
                      )
                  );
                }

                this.eplChildViewData = this.eplChildViewData.sort(
                  (x: any, y: any) => x.eplId - y.eplId
                );
                this.setExportData();
              }
            }

            this.selectedItemIds.clear();

            if (response?.message) {
              this.commonService.showNotificationMessage(
                `${response.message}`,
                'success',
                'center'
              );
            }
          }
        }
      },
    });
  }

  setExportData() {
    this.eplChildViewData.forEach((childData: any) => {
      let parentIndex = this.eplMasterViewData.findIndex(
        (masterData: any) => childData.eplId == masterData.changeItemEPLId
      );
      if (parentIndex > -1) {
        childData.isParentIndexIsOdd = parentIndex + 1;
      }
    });

    this.eplExportData = this.eplChildViewData.map((x: any) => {
      return {
        emdmKey: x.emdmKey,
        tagNumber: x.tagNumber,
        eplShort: x.eplShort,
        eplLong: x.eplLong,
        subAssemblyComp: x.subAssemblyComp,
        itemShort: x.itemShort,
        itemLong: x.itemLong,
        quantity: x.quantity,
        description: x.description,
      };
    });
  }

  showAddTagPopup = false;
  selectedEPLId = 0;

  openAddTagPopUp(dataItem: any, index: number) {
    this.selectedEPLId = dataItem.changeItemEPLId ?? 0;
    this.showAddTagPopup = this.selectedEPLId > 0;
  }

  clickExport(event: Event): void {
    this.eplService.getExportData(this.crNo).subscribe({
      next: (response: any) => {
        if (response?.length > 0) {
          this.eplExportData = response.map((x: any) => {
            return {
              emdmKey: x.emdmKey,
              tagNumber: x.tagNumber,
              eplShort: x.eplShort,
              eplLong: x.eplLong,
              subAssemblyComp: x.parentItemShort,
              itemShort: x.itemShort,
              itemLong: x.itemLong,
              quantity: x.quantity,
              description: x.description,
            };
          });
          let custName =
            'export_epl_items_CR' +
            this.crNo +
            '_' +
            this.commonService.getCurrentUTCDateTime();

          let exportData =
            this.selectedItemIds.size == 0
              ? this.eplExportData
              : this.eplExportData.filter((data: any, index: number) =>
                  this.selectedItemIds.has(index)
                );

          this.exportService.exportExcel(
            exportData,
            [this.exportColumns],
            custName
          );
          this.commonService.showNotificationMessage(
            'file downloaded successfully',
            'success',
            'center'
          );
          // this.exportEplData();
        }
      },
    });
  }

  clickImport(event: any) {
    this.showFileUploadPopup = true;
    this.popupTitle = 'Import new changes to change request #' + this.crNo;
    this.popupHeight = 250;
    this.popupWidth = 500;

    this.fieldValidationInput = [
      {
        title: 'EMDM Key',
        field: 'emdmKey',
        validations: ['required', 'maxLength=10', 'minLength=1'],
      },
      {
        field: 'tagNumber',
        title: 'Tag',
        validations: ['required'],
      },
      {
        title: 'ACD Action',
        field: 'acdAction',
        validations: ['required'],
      },
      {
        field: 'eplShort',
        title: 'EPL Short',
        validations: ['required'],
      },
      {
        field: 'eplLong',
        title: 'EPL Long',
        validations: ['required'],
      },
      {
        field: 'subAssemblyShort',
        title: 'Sub Assembly Short',
        validations: ['required'],
      },
      {
        field: 'itemShort',
        title: 'Item Short',
        validations: ['required'],
      },
      {
        field: 'itemLong',
        title: 'Item Long',
        validations: ['required'],
      },
      {
        field: 'quantity',
        title: 'Quantity',
        validations: [],
      },
      {
        field: 'description',
        title: 'Description',
        validations: [],
      },
    ];
  }

  imported(data: ImportData) {
    if (data.validationMsgs.length > 0) {
      this.commonService.showNotificationMessage(
        data.validationMsgs.join('<br>'),
        'error',
        'center'
      );
    } else {
      data.data.map((x: any, index: number) => {
        x.rowId = index;
        x.itemLong = String(x.itemLong);
      });
      this.eplService.importEPLBuild(this.crNo, data.data).subscribe({
        next: (response: any) => {
          if (response) {
            if (response.item1?.length > 0) {
              response.item1
                .filter((x: any) => !x.isAddedFromExcel)
                .forEach((x: any) => {
                  let isChangeDetected = false;
                  let eplData: any = this.eplChildData.find(
                    (viewData: any) => viewData.emdmKey == x.emdmKey
                  );
                  let viewData: any = this.eplChildViewData.find(
                    (viewData: any) => viewData.emdmKey == x.emdmKey
                  );
                  if (eplData && viewData) {
                    Object.keys(x).forEach((key: any) => {
                      if (this.mandatoryFieldList.includes(key)) {
                        if (x[key] != null && x[key] != viewData[key]) {
                          if (!viewData.fieldChangedList.includes(key)) {
                            viewData.fieldChangedList.push(key);
                          }

                          if (!isChangeDetected) {
                            isChangeDetected = true;
                          }

                          viewData[key] = x[key];
                        }
                      }
                    });

                    if (isChangeDetected && x.acdAction != 'Add') {
                      viewData.acdAction = 'Change';
                      viewData.acdId = this.commonService.setACDID(
                        viewData.acdAction
                      );
                    }
                  }
                });

              let newdata = response.item1.filter(
                (x: any) => x.isAddedFromExcel
              );

              newdata.map((x: any) => {
                x.tagNumberList = x.tagNumber?.split(',');
                // x.tagNumber_View = x.tagNumberList?.splice(0, 5).join(",<br>") ?? "";
                x.tagNumber_View =
                  x.tagNumber?.split(',')?.splice(0, 5).join(',<br>') ?? '';
                if (x.tagNumberList?.length > 5) {
                  x.tagNumber_View += '...';
                }
              });

              if (newdata.length > 0) {
                this.eplChildData = [...this.eplChildData, ...newdata];
                this.eplChildViewData = [...this.eplChildViewData, ...newdata];
                this.eplChildViewData = this.eplChildViewData.sort(
                  (x: any, y: any) => x.eplId - y.eplId
                );
              }

              this.setExportData();
            }

            if (response.item2) {
              this.commonService.showNotificationMessage(
                response?.item2,
                'error',
                'center'
              );
            }
          }
        },
      });
    }

    this.closePopup();
  }

  itemShortPopupOpen() {
    this.showItemShortPopup = true;
  }

  popupPageChanged(event: any) {
    if (this.popupOpenField == 'itemShort') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;

      this.getItemShortData();
    }
  }

  closePopup() {
    this.showFileUploadPopup = false;
    this.showTagPopup = false;
    this.showAddOrDeletePopup = false;
    this.selectedParameterId = 0;
    this.popupTitle = '';
    this.popupHeight = 400;
    this.popupWidth = 600;
    this.eplItems = '';
    this.eplId = 0;
    this.selectedEPLShort = 0;
    this.selectedParameterId = 0;

    this.addTagText = '';
    this.dataList = [];
    this.tagSelectedIds = [];
  }

  isUndoClicked = false;
  isValueChanged = true;

  onHeaderValueChange(dataItem: any, field: string, event: any) {
    this.isUndoClicked = false;
    this.isValueChanged = true;
    dataItem.fieldChangedList ??= [];
    let index = this.readyForUndoList_Header.findIndex(
      (x: any) => dataItem.changeitemId == x.changeitemId
    );
    if (index == -1) {
      this.readyForUndoList_Header.push(JSON.parse(JSON.stringify(dataItem)));
    } else {
      this.readyForUndoList_Header[index] = JSON.parse(
        JSON.stringify(dataItem)
      );
    }

    let ogData = this.eplMasterOgData.find(
      (x: any) => dataItem.changeitemId == x.changeitemId
    ) as { [key: string]: any };
    //let element = document.getElementById(`${dataItem.changeitemId}_${field}`);
    if (dataItem.acdAction != 'Add') {
      if (ogData[field]?.toString() !== event?.toString()) {
        //element.classList.add('backgroundChange');
        if (
          dataItem.fieldChangedList.find((x: string) => x == field) == undefined
        ) {
          dataItem.fieldChangedList.push(field);
        }
      } else {
        //element.classList.remove('backgroundChange');
        let index = dataItem.fieldChangedList.findIndex(
          (x: string) => x == field
        );
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction =
        dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.commonService.setACDID(dataItem.acdAction);
    }
  }

  onItemValueChange(
    dataItem: any,
    field: string,
    event: any,
    ogData: any = null
  ) {
    this.isUndoClicked = false;
    this.isValueChanged = true;
    dataItem.fieldChangedList ??= [];
    ogData =
      ogData ??
      (this.eplChildOgData.find(
        (x: any) =>
          dataItem.itemLong == x.itemLong && dataItem.eplLong == x.eplLong
      ) as { [key: string]: any });
    if (dataItem.acdAction != 'Add') {
      if (ogData && ogData[field]?.toString() !== event?.toString()) {
        if (
          dataItem.fieldChangedList.find((x: string) => x == field) == undefined
        ) {
          dataItem.fieldChangedList.push(field);
        }
      } else {
        let index = dataItem.fieldChangedList.findIndex(
          (x: string) => x == field
        );
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction =
        dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.commonService.setACDID(dataItem.acdAction);
    }
  }

  itemShortOpenedBomId = 0;

  openActionPopup(fieldName: string, index: number = -1, dataItem: any) {
    this.popupOpenField = fieldName;
    this.openedItemIndex = index;
    this.itemShortOpenedBomId = dataItem.bomId;

    if (this.popupOpenField == 'itemShort') {
      this.popupTitle = '';
      this.searchPlaceHolder =
        'Insert item number (total or partial) to search for';
      this.popupWidth = 600;
      this.getItemShortData();
    }
  }

  closeActionPopup(status: boolean) {
    this.popUpOpenFieldChangeItemId = 0;
    this.popupTitle = '';
    this.popupShow = status;
    this.searchPlaceHolder = '';
    this.serviceTypeList = [];
    this.serviceTypeSelectColumn = [];
    this.openedItemIndex = -1;
    this.skip = 0;
    this.itemShortOpenedBomId = 0;
    this.searchText = '';
  }

  getItemShortData() {
    this.eplService
      .getItemShortPopupData(this.skip, this.pageSize, this.searchText)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.popupDataList = {
              data: response.item1,
              total: response.item2,
            };
            this.popupShow = true;
          }
        },
        error: () => {
          this.popupDataList = { data: [], total: 0 };
          this.popupShow = true;
        },
      });
  }

  dataItemSelected(dataItem: any) {
    if (this.openedItemIndex > -1) {
      this.eplChildViewData[this.openedItemIndex].itemShort = dataItem.itm;
      let ogData = this.eplChildData.find(
        (x: any) => x.bomId == this.itemShortOpenedBomId
      ) as { [key: string]: any };
      if (ogData) {
        this.onItemValueChange(this.eplChildViewData[this.openedItemIndex], 'itemShort', dataItem.itm);
      }

      // this.eplChildViewData[this.openedItemIndex].itemLong = dataItem.itm.toString(); //need to change to Litm
      // this.eplChildViewData[this.openedItemIndex].description = dataItem.description1;
    }
    this.closeActionPopup(false);
  }

  deleteMasterChildEntry(changeItemEPLId: number) {
    this.clearSelectedHeader(changeItemEPLId);
  }

  clearSelectedHeader(changeItemEPLId: number = 0) {
    let isConfimed =
      changeItemEPLId > 0 ||
      window.confirm(
        'All selected records but the ones already added to CR will be cleared. Are you sure?'
      );

    if (isConfimed) {
      let payload = {
        crId: this.crNo,
        flag:
          changeItemEPLId == 0 &&
          this.selectedHeaderIds.size == this.eplMasterViewData.length
            ? 'SelectedAll'
            : 'Selected',
        item: '',
      };

      if (changeItemEPLId == 0 && this.selectedHeaderIds.size > 0) {
        payload.item = Array.from(this.selectedHeaderIds).join(',');
      } else {
        payload.item = `${changeItemEPLId}`;
      }

      this.deleteSelectedEntries(payload, changeItemEPLId, true);
    }
  }

  clearSelectedItems(changeItemId: number = 0) {
    let isConfimed =
      changeItemId > 0 ||
      window.confirm(
        'All selected records but the ones already added to CR will be cleared. Are you sure?'
      );

    if (isConfimed) {
      let payload = {
        crId: this.crNo,
        flag: 'Selected',
        item: '',
      };

      if (changeItemId == 0 && this.selectedHeaderIds.size > 0) {
        payload.item = Array.from(this.selectedHeaderIds).join(',');
      } else {
        payload.item = `${changeItemId}`;
      }

      this.deleteSelectedEntries(payload, changeItemId, false);
    }
  }

  deleteSelectedEntries(
    payload: any,
    changeItemId: number = 0,
    isHeader: boolean = false
  ) {
    this.eplService.deleteSelectedHeader(payload).subscribe({
      next: (response: any) => {
        if (response == 'Deleted Successfully') {
          let count =
            changeItemId > 0
              ? 1
              : isHeader
              ? this.selectedHeaderIds.size
              : this.selectedItemIds.size;
          this.commonService.showNotificationMessage(
            `${count} record(s) cleared from CR successfully.`,
            'success',
            'center'
          );

          if (changeItemId == 0) {
            this.loadGridData();
          } else {
            let deletedEplIds = this.eplMasterViewData
              .filter((x: any) => x.changeItemId == changeItemId)
              .map((x: any) => x.changeItemEPLId);
            this.eplMasterViewData = JSON.parse(
              JSON.stringify(
                this.eplMasterViewData
                  .filter((x: any) => x.changeItemId != changeItemId)
                  .sort(
                    (x: any, y: any) => x.changeItemEPLId - y.changeItemEPLId
                  )
              )
            );
            this.eplChildViewData = JSON.parse(
              JSON.stringify(
                this.eplChildViewData
                  .filter((x: any) => !deletedEplIds.includes(x.eplId))
                  .sort((x: any, y: any) => x.eplId - y.eplId)
              )
            );

            this.eplChildViewData = this.eplChildViewData.sort(
              (x: any, y: any) => x.eplId - y.eplId
            );
            this.setExportData();
          }
        }
      },
      error: (err: any) => {
        if (isHeader) {
          this.selectedHeaderIds.clear();
        } else {
          this.selectedItemIds.clear();
        }
      },
    });
  }

  deleteChildrowbyId(dataItem: any) {
    let index = this.eplChildViewData.findIndex((x: any) => {
      return dataItem.itemLong === x.itemLong;
    });

    if (index > -1) {
      this.eplChildViewData[index].acdAction = 'Delete';
    }
  }

  undoChildrowbyId(dataItem: any) {
    let index = this.eplChildViewData.findIndex(
      (x: any) => dataItem.changeItemId == x.changeItemId
    );
    if (index > -1) {
      let viewDataIndex = this.eplChildOgData.findIndex(
        (x: any) => dataItem.changeItemId == x.changeItemId
      );
      if (viewDataIndex > -1) {
        this.eplChildViewData[index] = JSON.parse(
          JSON.stringify(this.eplChildOgData[index])
        );
      }
    }
  }

  undoDeleteId(dataItem: any) {
    if (dataItem.isLocal) {
      let index = this.eplMasterViewData.findIndex((x: any) => {
        dataItem.eplShort === x.eplShort && dataItem.isLocal == true;
      });
      if (index) {
        this.eplMasterViewData.splice(index, 1);
      }
    }
  }

  backBTNClicked() {
    this.stepNavigateTo.emit('Search');
  }

  deleteItem(dataItem: any) {
    dataItem.acdAction = 'Delete';
  }

  undoItem(dataItem: any, rowIndex: number) {
    let ogDataItem = this.eplChildOgData.find(
      (x: any) =>
        dataItem.itemLong == x.itemLong && dataItem.eplLong == x.eplLong
    );

    if (ogDataItem && rowIndex >= 0) {
      let ogData = JSON.parse(JSON.stringify(ogDataItem));
      this.eplChildViewData[rowIndex].acdAction = ogData.acdAction;
      this.eplChildViewData[rowIndex].itemShort = ogData.itemShort;
      this.eplChildViewData[rowIndex].quantity = ogData.quantity;

      this.eplChildViewData[rowIndex].fieldChangedList = [];
      this.eplChildViewData[rowIndex].modifiedFields = '';
    }
  }

  removeItem_Action_Add(rowIndex: number) {
    let bomId = this.eplChildViewData[rowIndex].bomId;

    this.eplChildViewData.splice(rowIndex, 1);

    if (this.selectedItemIds.has(rowIndex)) {
      this.selectedItemIds.delete(rowIndex);
    }

    if (bomId != null && bomId > 0) {
      this.eplChildDeletedItemIds.add(bomId);
    }
  }

  mainGridRowCallback(context: RowClassArgs) {
    if ((context.index + 1) % 2 == 0) {
      return { even: true };
    } else {
      return { odd: true };
    }
  }

  public rowCallback = (context: RowClassArgs) => {
    if (context.dataItem.isParentIndexIsOdd % 2 == 0) {
      return { even: true };
    } else {
      return { odd: true };
    }
  };

  @ViewChild(TooltipDirective) public tooltipDir!: TooltipDirective;
  tagNumberList: string[] = [];

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    this.tagNumberList = [];
    if (
      element.nodeName === 'SPAN' &&
      (element.className === 'headerTagNumberSpan' ||
        element.className === 'itemTagNumberSpan')
    ) {
      if (
        element.id.includes('headerTagNumber_') &&
        element.id.split('_').length > 1
      ) {
        let index = parseInt(element.id.split('_')[1]);

        this.tagNumberList = this.eplMasterViewData[index].tagNumberList;
      } else if (
        element.id.includes('itemTagNumber_') &&
        element.id.split('_').length > 1
      ) {
        let index = parseInt(element.id.split('_')[1]);

        this.tagNumberList = this.eplChildViewData[index].tagNumberList;
      }
      if (this.tagNumberList.length > 5) {
        this.tooltipDir.toggle(element);
      }
    } else {
      this.tooltipDir.hide();
    }
  }
}
